import { render } from "./MappaDeiTalenti.vue?vue&type=template&id=393e5364&scoped=true"
import script from "./MappaDeiTalenti.vue?vue&type=script&lang=js"
export * from "./MappaDeiTalenti.vue?vue&type=script&lang=js"

import "./MappaDeiTalenti.vue?vue&type=style&index=0&id=393e5364&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393e5364"]])

export default __exports__